import { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";
import { apiFetch } from "../../utils/api";

const PreferenciasPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const eliminarItem = async (id) => {
    setIsLoading(true);
    try {
      const data = await apiFetch(`/api/preferences/${id}`,{
        method: "DELETE",
      });
      if(data.status){
        setDatos([])
        cargarDatos();
      } else {
        window.notie?.alert({ type: 'warning', text: data.message || 'No se pudo eliminar la preferencia' });
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error:', error);
      setIsLoading(false);
    }
  }

  const [datosTabla] = useState({
    titulo: "Preferencias",
    ruta: "/preferencia",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable,
  })

  const [cabecera] = useState([
    { title: "ID", key: "id" },
    { title: "NOMBRE", key: "nombre" },
    { title: "TOKEN", key: "token" },
    { title: "ACTIVO", key: "activo" },
    { title: "FECHA ALTA", key: "createdAt", isDate: true },
  ]);

  const cargarDatos = async () => {
    try {
      const data = await apiFetch("/api/preferences",{ method: "GET" });
      if(data.status){
        setDatos(Array.isArray(data.data) ? data.data : []);
      } else {
        setDatos([]);
        window.notie?.alert({ type: 'warning', text: data.message || 'No se pudieron cargar las preferencias' });
      }
    } catch (error) {
      console.error('Error:', error);
      setDatos([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default PreferenciasPage;
